module.exports = __webpack_public_path__ + "static/media/customer-6.c11b6f38.jpg";